import { render, staticRenderFns } from "./FilterTermSingle.vue?vue&type=template&id=5c2b755c&scoped=true&"
import script from "./FilterTermSingle.vue?vue&type=script&lang=js&"
export * from "./FilterTermSingle.vue?vue&type=script&lang=js&"
import style0 from "./FilterTermSingle.vue?vue&type=style&index=0&id=5c2b755c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b755c",
  null
  
)

export default component.exports